import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import TCpdf from "../../media/PrivacyPortalTermsofUseAgreementFinal.pdf";
import * as rk from "../../localization/resourceKeys";
import i18n from "../../i18n";
import "./BottomLine.css";
import PropTypes from "prop-types";

const BottomLine = (props) => {
  const openTandCpdf = () => {
    window.open(TCpdf);
  };

  const openTandCLink = () => {
    let termsAndConditionsUrl = "";
    const origin = window.location.origin?.toLowerCase();
    if(props.language === "FRA") {
      if(origin?.includes('vwfinance.ca')) {
        termsAndConditionsUrl = "https://content.ownerportal.vwcredit.io/tnc/can/vw/?lng=frCA";
      } else if(origin?.includes('audifinance.ca')) {
        termsAndConditionsUrl = "https://content.ownerportal.vwcredit.io/tnc/can/audi/?lng=frCA";
      }
    } else {
      if(origin?.includes('vwfinance.ca')) {
        termsAndConditionsUrl = "https://content.ownerportal.vwcredit.io/tnc/can/vw/?lng=enCA";
      } else if(origin?.includes('audifinance.ca')) {
        termsAndConditionsUrl = "https://content.ownerportal.vwcredit.io/tnc/can/audi/?lng=enCA";
      }
    };
    window.open(termsAndConditionsUrl);
  };

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    props.updateLanguage({
      language: lang === "en-CA" ? "ENG" : "FRA",
    });
    sessionStorage.setItem('language', lang);
  }

  const year = new Date().getFullYear();

  return (
    <div className="bottom-line">
      {(props.country)?.toLowerCase() === "canada" ? (
        <div className="u-pb-large">
          <p className="u-float-left">
            &copy; {i18n.t(rk.FOOTER.VWCREDIT, {year})}
            <span
              style={{ color: "#007eb2", cursor: "pointer" }}
              onClick={openTandCLink}
              data-testid="termsAndConditionsLink"
            >
              {i18n.t(rk.FOOTER.T_AND_C)}
            </span>
          </p>
          <span className="u-float-right language-toggle">
            <i className="c-icon  c-icon--[globe] c-icon--xxsmall u-pr-xsmall" />
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              className={(props.language)?.toLowerCase() === "eng" ? "active" : ""}
              rel="noopener noreferrer"
              data-testid="en-CA-language-toggle"
              onClick={() => changeLanguage("en-CA")}
            >
              {i18n.t(rk.FOOTER.LANGUAGE_ENGLISH)}
            </a>
            <span className="separator u-pr-xsmall u-pl-xsmall">|</span>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              className={(props.language)?.toLowerCase() === "fra" ? "active" : ""}
              rel="noopener noreferrer"
              data-testid="fr-CA-language-toggle"
              onClick={() => changeLanguage("fr-CA")}
            >
              {i18n.t(rk.FOOTER.LANGUAGE_FRENCH)}
            </a>
          </span>
        </div>
      ) : (
        <p className="u-text-center u-pb-small">
          &copy; {i18n.t(rk.FOOTER.VWCREDIT, {year})}
          <span
            style={{ color: "#007eb2", cursor: "pointer" }}
            onClick={openTandCpdf}
            data-testid="termsAndConditionsLink"
          >
            {i18n.t(rk.FOOTER.T_AND_C)}
          </span>
        </p>
      )}
    </div>
  );
}

BottomLine.propTypes = {
  language: PropTypes.string,
  country: PropTypes.string,
  updateLanguage: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    country: state.initialReducer.country,
    language: state.initialReducer.language,
  };
};

const mapDispatchToProps = dispatch => ({
  updateLanguage: values => dispatch({ type: "UPDATE_LANGUAGE", payload: values }),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(BottomLine));
